import React, { useCallback, useEffect, useState } from "react";
import {
    Row,
    Col,
    ProgressBar,
    Spinner
} from "react-bootstrap";
import { FiEye } from "react-icons/fi";
import "./EmployeeReviewDashboard.css";
// Components ----------------------------------------------
import SlabWiseTds from "./SlabWiseTds";
import Overview from "./Overview";
import Hra from "./Hra"
import HomeLoan from "./Home-loan";
import DeductionsReview from "./deduction";
import Donation from "./donation";
import Document from "./document";
// Redux ---------------------------------------------------
import { useDispatch } from "react-redux";
import { useSelect } from "../../../../../../../services/commonServices";
import { getEmployeePayrollRecordsPath } from "../../../../../../../services/config";
import { getTdsEmpListData, initTdsEmpList } from "../../../../../../../redux/slices/tdsSlice";
import { getTDSDeclarationFormPath } from '../../../../../../../services/config';
import { getTdsDecListData, initDecList } from '../../../../../../../redux/slices/tdsSlice';


export default function EmployeeReviewDashboard() {
    const user = JSON.parse(localStorage.getItem("user_data")) || {}
    const currentUser = JSON.parse(localStorage.getItem("tdsUser") || "{}")

    const dispatch = useDispatch()
    const tdsStore = useSelect("tds")

    const [isTabActive, setIsTabActive] = useState(1)
    const [tdsEmpList, setTdsEmpList] = useState([])
    const staffId = currentUser?.staffId ?? tdsEmpList[0]?.staffId
    const [reviewTdsDeclaration, setReviewTdsDeclaration] = useState({})
    const [tdsCalculation, setTdsCalculation] = useState({})
    const [regimeType, setRegimeType] = useState("")

    const getEmpRecordList = useCallback(() => {
        const formData = {
            path: getEmployeePayrollRecordsPath,
            data: {
                userId: user.user_id
            }
        }
        dispatch(getTdsEmpListData(formData))
    }, [])

    const getReviewTdsDeclaration = useCallback(() => {
        const formData = {
            path: getTDSDeclarationFormPath,
            data: {
                staffId: staffId
            }
        }
        dispatch(getTdsDecListData(formData))
    }, [])

    useEffect(() => {
        if (tdsStore.tdsEmpListData === null) {
            getEmpRecordList()
        } else {
            setTdsEmpList(tdsStore.tdsEmpListData)
        }

        if (tdsStore.tdsDeclData === null) {
            getReviewTdsDeclaration()
        } else {
            setReviewTdsDeclaration(tdsStore.tdsDeclData ?? {})
            setTdsCalculation(tdsStore.tdsDeclData.tdsCalculation ?? {})
            setRegimeType(tdsStore.tdsDeclData?.tdsCalculation?.selectedRegime ?? "old")
        }
    }, [])

    useEffect(() => {
        if (tdsStore.tdsEmpListSuccess) {
            setTdsEmpList(tdsStore.tdsEmpListData)
            dispatch(initTdsEmpList())
        }
        //tds calculation------------
        if (tdsStore.tdsDeclSuccess) {
            setReviewTdsDeclaration(tdsStore.tdsDeclData)
            setTdsCalculation(tdsStore.tdsDeclData.tdsCalculation ?? {})
            setRegimeType(tdsStore.tdsDeclData?.tdsCalculation?.selectedRegime ?? "old")
            dispatch(initDecList())
        }
    }, [tdsStore])

    const tabs = [
        {
            id: 1, label: "Overview", components: <Overview
                tdsEmpList={tdsEmpList}
                regimeType={regimeType}
                setRegimeType={setRegimeType}
                reviewTdsDeclaration={reviewTdsDeclaration}
                tdsCalculation={tdsCalculation}
            />
        },
        {
            id: 2, label: "Slab wise TDS", components: <SlabWiseTds
                tdsEmpList={tdsEmpList}
                regimeType={regimeType}
                setRegimeType={setRegimeType}
                reviewTdsDeclaration={reviewTdsDeclaration}
                tdsCalculation={tdsCalculation}
            />
        },
        {

            id: 3,
            label: "HRA",
            components: (
                <Hra
                    currentUser={currentUser}
                    tdsEmpList={tdsEmpList}
                    reviewTdsDeclaration={reviewTdsDeclaration}
                    tdsCalculation={tdsCalculation}
                />
            )
        },


        {
            id: 4,
            label: "Home-Loan",
            components: (
                <HomeLoan
                    currentUser={currentUser}
                    tdsEmpList={tdsEmpList}
                    reviewTdsDeclaration={reviewTdsDeclaration}
                    tdsCalculation={tdsCalculation}
                />
            )
        },
        {
            id: 5,
            label: "Deductions",
            components: <DeductionsReview
                currentUser={currentUser}
                tdsEmpList={tdsEmpList}
                reviewTdsDeclaration={reviewTdsDeclaration}
                tdsCalculation={tdsCalculation}
            />
        },
       {
            id: 6,
            label: "Donations",
            components: <Donation
                currentUser={currentUser}
                tdsEmpList={tdsEmpList}
                reviewTdsDeclaration={reviewTdsDeclaration}
                tdsCalculation={tdsCalculation}
            />
        },

        {
              id: 7,
            label: "Documents",
            components: <Document
                currentUser={currentUser}
                tdsEmpList={tdsEmpList}
                reviewTdsDeclaration={reviewTdsDeclaration}
                tdsCalculation={tdsCalculation}
            />
        }
    ]

    const activeComponent = tabs.find(item => item.id === isTabActive).components

    return (
        <div className="erd-page" style={{
            height: 'calc(100vh - 80px)',  // Adjust 80px to match your header height
            overflowY: 'auto',
            //   background:'grey',
            // Enables vertical scrollbar when needed
        }}>
            <Row>
                <Col sm='12'>
                    <div className="setting-border p-3 height-auto d-flex align-items-center justify-content-between gap-2 mb-2">
                        <div>
                            <div className="color-white font-weight-200">{currentUser.employeeName ?? tdsEmpList[0]?.employeeName}</div>
                            <div className="font-12 color-gray">{currentUser.employeeId ?? tdsEmpList[0]?.employeeId} · {currentUser.panNumber ?? tdsEmpList[0]?.panNumber ?? "-"} · FY {currentUser.fy ?? tdsEmpList[0]?.fy ?? "-"}</div>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <span className="badge-yellow">Under Review</span>
                            <button variant="link" className="erd-top-link font-14 font-weight-200" style={{ border: "none", background: "transparent" }}><FiEye /> View Audit Trail</button>
                            <div className="setting-border p-1 height-auto align-items-center gap-2" style={{ width: "200px" }}>
                                <span className="color-gray font-12 font-weight-200">Progress</span>
                                <ProgressBar now={75} className="my-gradient-bar" />
                            </div>
                        </div>
                    </div>

                    <div className="erd-tabs">
                        {tabs.map((t) => (
                            <button key={t.id} className={`${t.id === isTabActive ? 'erd-tab active color-white' : 'erd-tab color-white'}`} onClick={() => setIsTabActive(t.id)}>{t.label}</button>
                        ))}
                    </div>
                </Col>
            </Row>

            {tdsStore.tdsEmpListLoading ? <span style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}>
                <Spinner
                    as="span"
                    animation="border"
                    size="md"
                    role="status"
                    aria-hidden="true"

                /> Data loading please wait...
            </span> : tdsEmpList.length > 0 ? activeComponent : <span style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}>
                Data not found
            </span>}

        </div>
    );
}
